<div class="tcback" (click)="cancelled.emit()"></div>
<div class="tcdlg" role="dialog" appDialogFocus [attr.aria-label]="S['Choose a template']" (keydown.escape)="cancelled.emit()">
  <header class="tcdlg__head">
    <h2 class="tcdlg__title">{{ S['Choose a template'] }}</h2>
    <button class="iconbtn iconbtn--bare" [title]="S.Close" (click)="cancelled.emit()" [attr.aria-label]="S.Close">
      <app-icon name="close" size="16" />
    </button>
  </header>
  <p class="tcdlg__sub">{{ S['Choose a starting point, then make it your own in the editor.'] }}</p>

  <ul class="tclist">
    @for (starter of starters; track starter.kind) {
      <li>
        <button type="button" class="tcitem" [attr.data-testid]="'template-starter-' + starter.kind" (click)="chosen.emit({ starter: starter.kind })">
          <app-icon class="tcitem__icon" name="template" size="20" />
          <span class="tcitem__text">
            <strong>{{ starter.title }}</strong>
            <span>{{ starter.description }}</span>
          </span>
          <app-icon name="chevron" size="16" />
        </button>
      </li>
    }
    @for (template of templates(); track template.id) {
      <li>
        <button type="button" class="tcitem" data-testid="template-saved" (click)="chosen.emit({ template: template.id })">
          <app-icon class="tcitem__icon" name="template" size="20" />
          <span class="tcitem__text">
            <strong>{{ template.title }}</strong>
            <span>{{ (template.description | stchItemDescriptionText) || S['Saved workbook template'] }}</span>
          </span>
          <app-icon name="chevron" size="16" />
        </button>
      </li>
    }
  </ul>

  <footer class="tcdlg__foot">
    <button class="btn btn--ghost" (click)="cancelled.emit()" [attr.aria-label]="S['Cancel']">{{ S['Cancel'] }}</button>
  </footer>
</div>
